import React, {Component} from "react";
import {Link} from "react-router-dom";

import Bounce from "react-reveal/Bounce";

import Flash from "react-reveal/Flash";

class SureBuilt2026ConferenceSubmissions extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        document.getElementById("header").scrollIntoView();
    }

    render() {
        let image_margin = "20px 0 0 0";
        let marginTop = "5%";

        if (window.innerWidth < 850) {
            image_margin = "-40px 0px 0px 0px";
            marginTop = "20%";
        }

        return (
            <div style={{ marginTop: "80px" }}>
                <section class="call-to-action-box no-padding">
                    <div class="container" style={{ marginBottom: "20px" }}>
                        <div class="action-style-box">
                            <h2 class="column-title" style={{ color: "black", textAlign: "center" }}>
                                Conference Paper Submissions - SURE-Built 2026
                            </h2>
                        </div>
                    </div>
                </section>

                <Bounce right fraction={0.01}>
                    <section id="main-container" class="main-container">
                        <div className="container" style={{marginTop: "-50px"}}>

                            <div className="row" style={{marginTop: marginTop}}>
                                <div className="col-lg-12">
                                    <Bounce left>
                                        <h3 className="column-title">Abstract and Paper Submission Information </h3>
                                    </Bounce>

                                    <p>
                                        Please submit your abstract of not more than 300 words and include up to 5
                                        keywords online via the google link {" "}

                                        <a href="https://forms.gle/6QUQGmJ5g7ByTJ2B6" style={{color: "red"}}
                                           target="blank">
                                            {" "}
                                            here{" "}
                                        </a>
                                    </p>

                                    <p>
                                        The abstract template can be assessed by clicking{" "}
                                        <a href="https://tinyurl.com/bdz9xw57" style={{color: "red"}} target="blank">
                                            here
                                        </a>
                                    </p>

                                    <p>
                                        Abstracts will be sent to two referees.<b/>

                                        Only the authors of abstracts that pass this peer-review process will be invited
                                        to submit full papers.
                                    </p>
                                    <p>All authors can only be listed on a maximum of two papers.</p>
                                    <p>The deadline for the submission of abstracts is 23:59hrs GMT on 31st January, 2026 </p>
                                </div>
                            </div>

                            <div className="row">


                                <div className="col-lg-6 mt-5 mt-lg-0">
                                    <div id="page-slider" className="page-slider small-bg"
                                         style={{margin: image_margin}}>
                                        <img
                                            src="images/sure-built-2026-bar-code-1.png"
                                            alt="SureBuilt 2026"
                                            style={{
                                                maxWidth: "100%",
                                                height: "auto",
                                                objectFit: "contain",
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="row" style={{marginTop: "2%"}}>
                                <div className="col-lg-12">
                                    <Bounce left>
                                        <h3 className="column-title">Conference Topics and Sub-topics</h3>
                                    </Bounce>

                                    <p>
                                        The papers submitted for the conference might explore topics included but are
                                        not limited to the following::
                                    </p>


                                    <ul>
                                        <li><span style={{color: "red"}}>Track 1: Built environment methodologies</span>
                                            <ul>
                                                <li>Relevant methods used in construction design and research.</li>
                                            </ul>
                                        </li>
                                        <li><span style={{color: "red"}}> Track 2: Construction and project management</span>
                                            <ul>
                                                <li>Construction performance, construction management practices, procurement, industry development, project financing, etc.</li>
                                            </ul>
                                        </li>
                                        <li><span
                                            style={{color: "red"}}> Track 3: Digital built environment</span>
                                            <ul>
                                                <li>BIM, digitalisation, visualisation, smart innovative building technologies, big data and cloud computing, internet of things, robotics, integrated digital delivery, etc.</li>
                                            </ul>
                                        </li>
                                        <li><span style={{color: "red"}}> Track 4: Education in the built environment</span>
                                            <ul>

                                                <li>Student-centred Learning, GenAI in teaching and learning, built environment education in the era of Industry 5.0, game-based learning and gamification in the built environment, built environment pedagogies, etc.</li>
                                            </ul>
                                        </li>
                                        <li><span style={{color: "red"}}> Track 5: Housing Science</span>
                                            <ul>

                                                <li>Housing affordability, sustainable housing, urban housing development, housing economics, land use planning, housing policy and regulation, historical housing trends, cultural influence in housing, etc</li>
                                            </ul>
                                        </li>
                                        <li><span style={{color: "red"}}> Track 6: Infrastructure and industry development</span>
                                            <ul>

                                                <li>Infrastructure development and resilience, maintenance management, regulatory framework and government initiatives, ethics and professional development, equality, diversity and inclusivity smart infrastructure, etc.</li>
                                            </ul>
                                        </li>
                                        <li><span style={{color: "red"}}> Track 7: Sustainable development and Agenda 2063</span>
                                            <ul>

                                                <li>Carbon emissions and energy usage, sustainable construction, climate change adaptation and resilience, heritage and preservation, circular economy, nature-based solutions, indoor environmental quality and management, emerging sustainable innovative materials and methods, etc.</li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div className="row" style={{marginTop: "2%"}}>
                                <div className="col-lg-12">
                                    <Bounce left>
                                        <h3 className="column-title">Contact</h3>
                                    </Bounce>

                                    <p>For more information or any queries send an email to: surebuiltseries@gmail.com</p>
                                </div>
                            </div>


                        </div>
                    </section>
                </Bounce>

                <section class="call-to-action-box no-padding">
                    <div class="container" style={{marginBottom: "20px"}}>
                        <div class="action-style-box">
                            <div class="row align-items-center">
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/2026-sure-built-conference">
                                                {" "}
                                                <a class="btn btn-dark">Conference Overview</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/2026-sure-built-conference-information">
                                                {" "}
                                                <a class="btn btn-dark">Conference Information</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                                <div class="col-md-4 text-center text-md-right mt-3 mt-md-0">
                                    <div class="call-to-action-btn">
                                        <Flash count={2}>
                                            <Link to="/">
                                                {" "}
                                                <a class="btn btn-dark">Back to CR Centre</a>{" "}
                                            </Link>
                                        </Flash>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default SureBuilt2026ConferenceSubmissions;